import i18n from 'i18next'
import LanguageDetector from 'i18next-browser-languagedetector'
import Backend from 'i18next-http-backend'
import { initReactI18next } from 'react-i18next'

import { locale } from 'data/locale'

const { en, fr } = locale()

i18n
  .use(Backend)
  .use(LanguageDetector)
  .use(initReactI18next)
  .init({
    resources: {
      en: {
        translation: { ...en }
      },
      fr: {
        translation: { ...fr }
      }
    },
    fallbackLng: 'en',
    lng: localStorage.getItem('lang') || 'en',
    interpolation: {
      escapeValue: false
    }
  })

export default i18n
